import { Controller } from "stimulus"

// Receives the realtime queue-invalidation signal. The broadcast carries no rows - just that the
// queue changed, how long it now is, and which row is at the head - which is everything the badge
// and the fixed player's up-next need. Only the queue page has to go and fetch rows, and it does
// that off the `supercast-queue-changed` this controller dispatches.
export default class extends Controller {
  static values = { signal: Boolean, origin: String, count: Number, headId: Number, headItemId: Number }

  // Keyed on `signal`, not on `origin`: native clients mint no client id, so their changes arrive
  // with an empty origin and an origin-based test would ignore them entirely.
  signalValueChanged(value) {
    // The layouts render this element with no values - a page load is not a change.
    if (!value) return

    // This device initiated the change and already applied the rows the mutation response
    // returned; re-applying would clobber an in-flight second edit.
    if (this.originValue && this.originValue === window.queueClientId) return

    // The signal below tells the current listeners everything they need, but a listener that
    // connects later falls back to queueClient.getQueue() - which would serve the snapshot this
    // change just invalidated.
    window.queueClient?.invalidate()

    window.dispatchEvent(
      new CustomEvent("supercast-queue-changed", {
        detail: {
          count: this.countValue,
          head: this.headIdValue ? { id: this.headIdValue, itemId: this.headItemIdValue } : null,
          rendered: false
        }
      })
    )
  }
}
